import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=ecc6aa96"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"
import style0 from "./Rule.vue?vue&type=style&index=0&id=ecc6aa96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports